import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { MroGPSApiServiceMock } from '@mocks/mro-gps-api-mock.service';
import { MroGPSApiService } from '../mro-gps-api.service';
import { MroGPSRepository } from '../mro-gps.repository';

export const HTTP_MRO_GPS_SERVICE = new InjectionToken<MroGPSRepository>('MroGPSRepository');

export const MRO_GPS_API_PROVIDER: Provider = {
    provide: HTTP_MRO_GPS_SERVICE,
    useClass: environment.useMocks && environment.useMocks.mroGPS ? MroGPSApiServiceMock : MroGPSApiService,
};
